<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { fade } from 'svelte/transition';
    import { _ } from 'svelte-i18n';

    import AppMainStatusElement from './AppMainStatusElement.svelte';
    import { JobApi } from '../Jobs/JobApi';
    import { api, clientSettings } from '../../../stores/api';
    import {
        debug,
        featureTogglerVisible,
        jobs,
        mainMenu,
        planning,
        readonlyMode,
    } from '../../../stores/store';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import ProgressBarAnalytics from '../../shared/ProgressBarAnalytics.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import WhiteColor from '../../shared/WhiteColor.svelte';
    import TimeWindowNotification from '../Planning/TimeWindowNotification.svelte';
    import SelectHour from '../../shared/SelectHour.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { openModal } from 'svelte-modals';
    import ModalStartPlanning from '../Modals/ModalStartPlanning.svelte';
    import { ScenarioApi } from '../Planning/ScenarioApi';
    import ModalSelectVehicle from '../Modals/ModalSelectVehicle.svelte';
    import ProgressBarLight from '../../shared/ProgressBarLight.svelte';
    import { Navigation } from '../../utilities/Navigation';
    import { ExampleDataGenerator } from '../PageStart/ExampleDataGenerator';
    import { WarehouseApi } from '../Warehouses/WarehouseApi';
    import { VehiclesApi } from '../Vehicles/VehiclesApi';
    import { TacticalPlanApi } from '../TacticalPlan/TacticalPlanApi';
    import { CollectionApi } from '../Collections/CollectionApi';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import ModalCreateJob from '../Modals/ModalCreateJob.svelte';
    import PlanningStatus from './PlanningStatus.svelte';
    import ModalFeatures from '../../shared/Features/ModalFeatures.svelte';
    import GeocodingStatusWithProgressBar from '../Import/GeocodingStatusWithProgressBar.svelte';
    import { features } from '../../shared/Features/features';
    import NotificationSystem from '../NotificationSystem/NotificationSystem.svelte';
    import { disableRefreshing } from '../../../stores/store';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import ButtonSmallBlueRounded from '../../shared/ButtonSmallBlueRounded.svelte';
    import { app } from '../../../stores/app';
    import ButtonSmallDanger from '../../shared/ButtonSmallDanger.svelte';
    import { SettingsApi } from '../Settings/SettingsApi';
    import { z } from 'zod';
    import { ClientSettingsSchema } from '../Settings/settings';
    import { DaysWithJobsToProcessApi } from './DaysWithJobsToProcessApi';
    import { DaysWithJobsToProcessApp } from './DaysWithJobsToProcessApp';
    import SelectCustomerId from './SelectCustomerId.svelte';

    let error: string = '';
    let total: number = 0;
    let countOverdue: number | null = null;
    let countAdhoc: number | null = null;
    let count2: number | null = null;
    let count3: number | null = null;
    let count4: number | null = null;

    let percent2: number | null = null;
    let percent3: number | null = null;
    let percent4: number | null = null;

    let settimeoutHandler: any = null;
    let refreshing: boolean = true;
    let loading: boolean = true;
    let creatingJob: boolean = false;

    let timeoutMiliseconds: number = 10000;
    // let disableRefreshing: boolean = false;


    let daysApp: DaysWithJobsToProcessApp = new DaysWithJobsToProcessApp($api);

    function reloadData() {
        console.info('ignoring reload statuses');
        return;

        if (settimeoutHandler) {
            clearTimeout(settimeoutHandler);
        }
        Promise.all([
            JobApi.getCountWithQueries(
                get(api),
                { target_date: $planning.selectedDay },
                new ApiFilterBuilder(1)
            ),
            JobApi.getCountOverdue(get(api)),
            JobApi.getCountAdhoc(get(api), $planning.selectedDay),
            JobApi.getCountWithQueries(
                get(api),
                { process_status: 2, target_date: $planning.selectedDay },
                new ApiFilterBuilder(1)
            ),
            JobApi.getCountWithQueries(
                get(api),
                { process_status: 3, target_date: $planning.selectedDay },
                new ApiFilterBuilder(1)
            ),
            JobApi.getCountWithQueries(
                get(api),
                { process_status: 4, target_date: $planning.selectedDay },
                new ApiFilterBuilder(1)
            ),
        ])
            .then(response => {
                [total, countOverdue, countAdhoc, count2, count3, count4] = response.map(
                    r => r.count
                );
                if (total > 0) {
                    percent2 = Math.round((count2 / total) * 100);
                    percent3 = Math.round((count3 / total) * 100);
                    percent4 = Math.round((count4 / total) * 100);
                } else {
                    percent2 = null;
                    percent3 = null;
                    percent4 = null;
                }
                console.log(
                    'AppMainStatus, reloadData',
                    $disableRefreshing,
                    response,
                    total,
                    count2,
                    count3,
                    count4,
                    percent2,
                    percent3,
                    percent4
                );
            })
            .catch(err => {
                error = err;
                percent2 = null;
                percent3 = null;
                percent4 = null;
                console.error(err);
            })
            .finally(() => {
                if (timeoutMiliseconds > 0 && !$disableRefreshing) {
                    settimeoutHandler = setTimeout(reloadData, timeoutMiliseconds);
                }
                refreshing = false;
                loading = false;
            });
    }

    onMount(() => {
        daysApp.getDays([]).then(response => {
            daysApp = daysApp;
            console.log('AppMainStatus, getDaysWithJobsToProcess', response);
        }).catch(err => {
            console.error('AppMainStatus, getDaysWithJobsToProcess', err);
        });
        return () => {
            if (settimeoutHandler) {
                clearTimeout(settimeoutHandler);
            }
        };
    });

    $: {
        if ($planning.forceReload) {
            console.log('AppMainStatus, forceReload');
            setTimeout(() => {
                $planning.forceReload = false;
                reloadData();
            }, 0);
        }
    }

    $: {
        if ($jobs.forceRecount) {
            console.log('AppMainStatus, forceRecount');
            $jobs.forceRecount = false;
            reloadData();
        }
    }

    // $: $disableRefreshing = $debug;

    $: {
        if (refreshing === false) {
            setTimeout(() => {
                refreshing = true;
            }, 0);
        }
    }
</script>

<div
    style="display: flex; column-gap: 45px; flex-direction: row; padding: 0 5%; align-items: center; width:100%;"
    in:fade={{ duration: 250 }}
    out:fade={{ duration: 250 }}
>
    <AppMainStatusElement>
        <div style="font-size: 13px; color: #000c">{$_('selected_day')}:</div>
        <div
            style="color: #000f; font-size: 20px; font-weight:600; height: 100%; display: flex; align-content: center; align-items: center; min-width: 100px; flex-direction: row;"
        >
            <SelectDay
                bind:day={$planning.selectedDay}
                showRelativeToday={$clientSettings.display.showRelativeToday}
                daysApp = {daysApp}
                onChange={d => {
                    $jobs.forceRecount = true;
                    $planning.forceToSetTacticalPlan = true;
                    $mainMenu.currentPage = '';
                    $clientSettings.display.selectedDay = d;
                    if (!$readonlyMode) {
                        SettingsApi.setClientSettings(
                            get(api),
                            'settings',
                            $clientSettings,
                            ClientSettingsSchema
                        ).catch(e => {
                            alert('Error saving client settings');
                            console.error('Error saving client settings', e);
                        });
                    }
                    Navigation.navigate('/planning');
                }}
            />
        </div>
    </AppMainStatusElement>

    {#if $debug || ($app.session_expires_in_seconds && $app.session_expires_in_seconds < 120)}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            style="font-size: 13px; color: #000c; background-color: #fae06e; min-width: 225px;
  border-radius: 6px;
  padding: 5px 15px;
  margin: 5px 5px; cursor: pointer"
            on:click={() => {
                console.log('session is reloaded');
            }}
        >
            {$_('session_expiry_warning')}
        </div>
    {/if}

    {#if $readonlyMode}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            style="font-size: 13px; color: #000c; background-color: #fae06e; min-width: 225px;
  border-radius: 6px;
  padding: 5px 15px;
  margin: 5px 5px; cursor: pointer"
            on:click={() => {
                console.log('session is reloaded');
            }}
        >
            {$_('read_only_mode_enabled')}
        </div>
    {/if}

    <NotificationSystem disabled={$disableRefreshing} />

    <SelectCustomerId />

    {#if $debug}
        <Checkbox
            checked={!$disableRefreshing}
            label="Auto-refresh"
            onChange={() => {
                $disableRefreshing = !$disableRefreshing;
                if (!$disableRefreshing) {
                    reloadData();
                } else {
                    if (settimeoutHandler) {
                        clearTimeout(settimeoutHandler);
                    }
                }
            }}
        />
    {/if}
    {#if $debug || $featureTogglerVisible}
        <ButtonMain
            text="Features"
            on:click={() => {
                openModal(ModalFeatures, {});
            }}
        />
    {/if}

    {#if !error && !$disableRefreshing}
        <!--{#if $debug}-->
        {#if false}
            <AppMainStatusElement>
                <div style="font-size: 13px; color: #000c">{$_('Nagłe zlecenia')}:</div>
                <div
                    style="color: #000f; font-size: 20px; font-weight:600; height: 100%; display: flex; align-content: center; align-items: center; min-width: 100px; flex-direction: row;"
                >
                    {countAdhoc && countAdhoc >= 0 ? countAdhoc : '0'}
                </div>
            </AppMainStatusElement>
        {/if}

        {#if false}
            <AppMainStatusElement>
                <ProgressBarLight
                    currentValue={count2}
                    totalValue={total}
                    label={$_('Assigned')}
                    modeColor="blue"
                />
            </AppMainStatusElement>

            <AppMainStatusElement>
                <ProgressBarLight
                    currentValue={count3}
                    totalValue={total}
                    label={$_('Jobs in progress')}
                    modeColor="mint"
                />
            </AppMainStatusElement>

            <AppMainStatusElement>
                <ProgressBarLight
                    currentValue={count4}
                    totalValue={total}
                    label={$_('Completed')}
                    modeColor="green"
                />
            </AppMainStatusElement>
        {/if}
    {/if}

    {#if $debug && false}
        <ButtonSmallBlueRounded
            text="runStageProgress"
            on:click={async () => {
                console.log('runStageProgress');
                await ScenarioApi.runStageProgress(get(api));
            }}
        />
    {/if}

    {#if $debug && typeof $api.getIsLoggedOut == 'function'}
        <ButtonSmallDanger
            text={$api.getIsLoggedOut() ? 'Wylogowany' : 'Wyloguj'}
            disabled={$api.getIsLoggedOut()}
            on:click={() => {
                console.log('Triggering logout app');
                if (typeof $api.setIsLoggedOut === 'function') $api.setIsLoggedOut(true);
            }}
        />
    {/if}

    {#if $debug}
        {#if creatingJob}
            <Spinner />
        {:else}
            <ButtonMain
                text="Create random job"
                on:click={() => {
                    creatingJob = true;
                    JobApi.createOne(get(api), {
                        target_date: '2025-02-2' + Math.floor(Math.random() * 9),
                        address_attributes: {
                            city: 'Warszawa',
                            pcode: '02-288',
                            street: 'Kolumba ' + (Math.floor(Math.random() * 100) + 2),
                            country: 'PL',
                        },
                        special_attributes: {
                            delivery_or_collection:
                                Math.floor(Math.random() * 2) === 0 ? 'delivery' : 'collection',
                            parcels: Math.floor(Math.random() * 10) + 1,
                            total_weight: Math.floor(Math.random() * 100) + 1,
                            external_id:
                                '173811' + (Math.floor(Math.random() * 100) + 1).toString(),
                            label:
                                'Paczkomat lub Automat Paczkowy 474855' +
                                (Math.floor(Math.random() * 100) + 1).toString(),
                        },
                        client_attributes: {
                            'gotowo\u015b\u0107 odbioru od': '2025-02-04 12:00',
                            'gotowo\u015b\u0107 odbioru do': '2025-02-04 14:00',
                            utworzono: '2025-02-04 10:54',
                            'wysoko\u015b\u0107 najwy\u017cszej palety': '170 cm',
                            'cie\u017car najci\u0119\u017cszej palety': '400 kg',
                            'biznesowe ID zlecenia': '20250204719951',
                            'ID zlecenia': 173811810,
                            'zadeklarowana liczba palet': 1,
                            '# statusu': 10002,
                            'ID paczki': '1234567890',
                            waybill: '88888888ABC',
                        },
                        webuser_id: $app.account.getWebuserId(),
                        collection_id: 1,
                        job_type_id: 1,
                        import_id: 1,
                        order_created_date: '2025-02-04 12:04:08',
                    })
                        .catch(e => {
                            alert(e);
                        })
                        .finally(() => {
                            creatingJob = false;
                        });
                    // openModal(ModalCreateJob, {});
                }}
            />
        {/if}
    {/if}
</div>
